import { getQueryURL } from '../requestService';
import { client } from '../../client';
import { PaginatedResult, TilleggsdataKobling } from '../../../models';
import { PageParam, SortParam } from '../../rtk-queries/queryApiCreator';
import { EksportSettings } from '../../../models/eksportSettings';

export default class TilleggsdataKoblingService {
    serviceName = 'tilleggsdata/kobling';

    fetch = async (param: PageParam & SortParam & { refTab: string, refId: number; }) =>
        client.get<PaginatedResult<TilleggsdataKobling>>(getQueryURL(this.serviceName, param));
    create = async (item: TilleggsdataKobling) => client.post<TilleggsdataKobling>(this.serviceName, item);
    update = async (id: number, item: TilleggsdataKobling) => client.post<TilleggsdataKobling>(`${this.serviceName}/${encodeURIComponent(id)}`, item);
    deactivate = async (koblingIdList: number[], tilDato?: Date) => client.post(getQueryURL(`${this.serviceName}/avslutt`, { tilDato }), koblingIdList);
    delete = async (itemId: number) => client.delete<void>(`${this.serviceName}/${encodeURIComponent(itemId)}`);
    init_journalkategoriRef = async (refId: number) => client.get<TilleggsdataKobling>(`${this.serviceName}/journalkategori/${encodeURIComponent(refId)}/init`);
    init_sakstypeRef = async (refId: number) => client.get<TilleggsdataKobling>(`${this.serviceName}/sakstype/${encodeURIComponent(refId)}/init`);
    init_partsholdRef = async (refId: number) => client.get<TilleggsdataKobling>(`${this.serviceName}/partsforhold/${encodeURIComponent(refId)}/init`);
    eksport = async (eksportSettings: EksportSettings<TilleggsdataKobling>) => await client.getFile(`${this.serviceName}/eksport`, 'POST', eksportSettings);

}
